import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";

addToChainAfter(chain, PopulateApiParameter, ({ apiParameter }) => {
    apiParameter.additionalExpands = ["properties"];
    if (!("relationship" in apiParameter || apiParameter?.type === "alsoPurchased")
        && !("productIds" in apiParameter) // wholegoods products fetch 
        && !("filter" in apiParameter)) // product carousel fetch
    { 
        apiParameter.additionalExpands.push("fulfillmentoptions"); 
    }
});
